<template>
  <div>
    <div class="head">我的账单({{ billlenth }})</div>
    <el-table :data="tableData" class="tableHead" style="width: 100%; font-size: 10px">
      <el-table-column label="订单编号名称" width="200px">
        <template slot-scope="scope">
          <el-tooltip effect="light" :content="scope.row.orderName">
            <span style="margin-left: 10px">{{ scope.row.orderName }}<br />{{ scope.row.orderName }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="类型">
        <template slot-scope="scope">
          <span style="margin-left: 10px" v-show="scope.row.orderType == 1">支出</span>
          <span style="margin-left: 10px" v-show="scope.row.orderType == 2">充值</span>
          <span style="margin-left: 10px" v-show="scope.row.orderType == 3">收入</span>
        </template>
      </el-table-column>
      <el-table-column label="知识币">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.money }}</span>
        </template>
      </el-table-column>
      <el-table-column label="订单时间" width="150px">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.time }}</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="pageStyle">
      <el-pagination background @current-change="pageUpdate" :page-size="pageSize" layout="prev, pager, next"
        :total="billlenth">
      </el-pagination>
    </div>

    <!-- 在线充值/兑换知识币 -->
    <div class="recharge-money">
      <p id="recharge-title">在线充值/兑换知识币</p>
      <div class="recharge-contain">
        <span class="letter-spacing-2">充值金额：</span>
        <el-input v-model="rechargeNum" @input="proving" maxlength="3" placeholder="请输入充值金额(正整数)">
        </el-input>
        <span class="letter-spacing-2">充值方式：</span>
        <div class="pay-way">
          <div class="pay-ways inline-block vtc-mid" v-bind:class="{ 'pay-way-checked': !payWay }" @click="wayOfAlipay">
            <i class="el-icon-check icon" v-bind:class="{ 'icon-checked': !payWay }"></i>
            <img class="vtc-mid" src="../../../assets/icon/alipay.png" /> 支付宝
          </div>
          <span class="vtc-mid pay-manual">(1元 = 1个知识币)</span>
        </div>
      </div>
      <div style="text-align: center; margin-top: 15px">
        <el-button type="primary" @click="chargeImmed">立即充值</el-button>
      </div>
    </div>
    <div class="divform"></div>
  </div>
</template>

<script>
import { alipay, getBill } from "@/services";
import { showTimeFormat, Bringbill, getTimeFormat } from "@/js/common";
export default {
  data() {
    return {
      billlenth: 0,    //总条数
      page: 1,   //当前页
      userInfo: {},
      pageSize: 10,  //每页条数
      tableData: [],
      payWay: true, // 充值方式
      rechargeNum: "", // 充值金额
    };
  },
  created() {
    this.init();
  },

  methods: {
    // 立即充值
    chargeImmed() {
      if (!this.rechargeNum) {
        this.$message.warning("请输入充值金额!");
        return
      }
      this.tradeNo = Bringbill.call(this); // 订单号
      let data = {
        subject: '知识币充值',   //订单名称
        total_amount: this.rechargeNum * 1,   //金额
        body: '知识币充值',      //描述
        userId: this.userInfo.id
      }
      alipay(data).then(res => {
        console.log(res);
        if (res.success) {
          document.querySelector("body").innerHTML = res.data; //查找到当前页面的body，将后台返回的form替换掉他的内容
          document.forms[0].submit(); //执行submit表单提交，让页面重定向，跳转到支付宝页面
        } else {

        }
      })
    },

    //分页时
    pageUpdate(e) {
      this.page = e
      this.init()
    },


    //获取订单列表
    async init() {
      let userInfo = null;
      try {
        userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
        this.userInfo = userInfo
      } catch (error) {

      }
      if (!userInfo) {
        return
      }
      this.tableData = [];
      getBill({ uid: userInfo.id, pageIndex: this.page, pageSize: this.pageSize }).then(res => {
        if (res.success) {
          this.tableData = res.data.records
          this.billlenth = res.data.total
        }
      })
    },

    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },

    // 输入充值金额验证
    proving() {
      this.rechargeNum = this.rechargeNum
        .replace(/[^\.\d]/g, "")
        .replace(/^0{1,}/g, "");
      this.rechargeNum = this.rechargeNum.replace(".", "");
      if (this.rechargeNum > 500) this.rechargeNum = 500;
    },

    wayOfAlipay() {
      this.defaultWay = 1;
      this.payWay = false;
    },

  },
};
</script>
<style scoped>
.head {
  line-height: 50px;
  margin-left: 15px;
  font-size: 15px;
  font-weight: 800;
}
.el-table {
  border: 1px solid #d2d2d2;
  margin: 10px;
}

.el-table__body-wrapper {
  overflow: hidden;
  height: 400px !important;
  overflow-y: scroll;
  position: relative;
}

.el-rate {
  line-height: 1.3 !important;
}

/* 在线充值/兑换知识币 */
.recharge-money {
  padding-left: 10px;
  margin-top: 40px;
}

#recharge-title {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 600;
  color: #030303;
}

.letter-spacing-2 {
  letter-spacing: 2px;
}

.recharge-contain {
  padding: 20px;
  border: 1px solid #ebeef5;
}

.pay-way {
  margin-top: 8px;
  cursor: default;
}

.pay-ways {
  margin-right: 30px;
  border: 1px solid #ebeef5;
  padding: 10px 15px 10px 15px;
  cursor: pointer;
}

.pay-way div img {
  margin-right: 10px;
  max-width: 24px;
  height: auto;
}

.inline-block {
  display: inline-block;
}

.vtc-mid {
  vertical-align: middle;
}

.pay-manual {
  color: #c0c4cc;
}

.pay-way-checked {
  border: 1px solid #66a7fd;
  margin-right: 30px;
  padding: 10px 15px 10px 15px;
  position: relative;
}

.icon {
  position: absolute;
  display: none;
}

.icon-checked {
  position: absolute;
  display: block;
  top: -1px;
  right: 2px;
}

/* reset-style */
.el-input {
  position: relative;
  font-size: 14px;
  display: inline-block;
  width: 100%;
  margin-top: 7px;
  margin-bottom: 7px;
}

.el-icon-check:before {
  content: "\e6da";
  font-size: 13px;
  color: #16e3bb;
}

.pageStyle {
  display: flex;
  justify-content: center;
}
</style>
